module.exports = __webpack_public_path__ + "img/byteark-logo-monotone.265ad5fc.svg";